<template>
    <div class="highlighted-top-provider" v-if="providerData.length > 0">
        <template v-for="(topProvider, index) in providerData">
            <div
                :key="index"
                style="position: relative; margin-bottom: 30px"
                class="partner-row-outer"
            >
                <a
                    class="goto-link"
                    :href="gotoLink(topProvider)"
                    target="_blank"
                >
                </a>
                <div class="heading" v-if="index === 0 && showFlag">
                    <div class="ribbon">
                        {{ $t('TOP CHOICE AMONG OUR USERS') }}
                    </div>
                </div>
                <div
                    class="partner-row"
                    :style="
                        index !== 0 || !showFlag
                            ? { borderRadius: '8px' }
                            : { border: '1.5px solid var(--gw-btn-bg-color)' }
                    "
                >
                    <div class="logo">
                        <img
                            height="120px"
                            width="180px"
                            v-lazy="getLogo(topProvider)"
                            :alt="topProvider['provider_name']"
                        />
                    </div>
                    <a
                        class="review-link"
                        v-if="topProvider['review_url']"
                        :href="topProvider['review_url']"
                    >
                        <p>{{ $t('Read Full Review') }}</p>
                        <br />
                    </a>

                    <div class="name">
                        <p>{{ topProvider['provider_name'] }}</p>
                    </div>
                    <div class="desc">
                        <div
                            class="icons"
                            v-if="parseIcons(topProvider).length > 0"
                        >
                            <PartnerIcons
                                :partner-icons="parseIcons(topProvider)"
                                :max-icons-desktop="3"
                                :max-icons-mobile="4"
                                wrap-on-expand
                            >
                                <a
                                    class="partner-icon_link-wrapper"
                                    target="_blank"
                                    rel="nofollow"
                                ></a>
                            </PartnerIcons>
                        </div>
                        <div
                            v-html="
                                topProvider['marketing']['price'] ||
                                topProvider['marketing']['members']
                            "
                        />
                    </div>

                    <div
                        class="discount-btn"
                        v-if="topProvider['marketing']['discount btn']"
                    >
                        <p>
                            {{ topProvider['marketing']['discount btn'] }}
                        </p>
                    </div>

                    <div class="discount-btn" v-else></div>

                    <div class="rating">
                        <Rating
                            active-color="#e11d48"
                            inactive-color="#f4f4f5"
                            active-icon="star"
                            inactive-icon="star"
                            :rating="getScore(topProvider)"
                            height="20px"
                            width="20px"
                        />
                        <p class="score">{{ getScore(topProvider) }}</p>
                    </div>

                    <div class="cta-button">
                        <a :href="gotoLink(topProvider)" target="_blank">
                            <button>{{ $t('Try It Out Risk-Free') }}</button>
                        </a>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { ghostWriterRankingMixin } from '@/ghost-mixins';
import PartnerIcons from '@molecules/PartnerIcons/PartnerIcons.vue';

export default {
    name: 'HighlightedTopProvider',
    components: { PartnerIcons },
    mixins: [ghostWriterRankingMixin],
    props: {
        providers: {
            type: Array,
            default: () => [],
        },
        showSingleProvider: {
            type: Boolean,
            default: true,
        },
        showFlag: {
            type: Boolean,
            default: true,
        },
        highlightedProvider: {
            type: Object,
        },
    },
    computed: {
        providerData() {
            if (this.highlightedProvider) {
                return [this.highlightedProvider];
            }

            if (this.providers.length > 0 && this.showSingleProvider) {
                return [this.providers[0]];
            }

            if (this.providers.length > 0) {
                return this.providers;
            }

            return [];
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';

.highlighted-top-provider {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-top: 20px;

    .goto-link {
        width: 100%;
        height: 100%;
        position: absolute;
    }

    .review-link {
        grid-area: review-link;
        z-index: 50;
        color: var(--gw-btn-bg-color);
        font-weight: 600;
        text-align: center;
        font-size: 14px;
        transition: 3ms all ease;
        order: 6;
        display: flex;
        align-items: center;

        @include mq('tablet') {
            position: absolute;
            bottom: 24px;
        }

        @include mq('desktop') {
            text-align: left;
            margin-top: 14px;
            padding-left: 5px;
            position: unset;
        }
    }

    .heading {
        position: relative;

        .ribbon {
            --r: 0.4em;
            --c: var(--gw-btn-bg-color);
            font-size: 13px;
            font-weight: 600;
            color: var(--gw-btn-text-color);
            z-index: 2;
            position: absolute;
            top: -20px;
            left: 0;
            inset-inline: calc(-1 * var(--r));
            text-align: center;
            line-height: 2;
            padding: 0 0.5em calc(2 * var(--r));
            border-radius: var(--r);
            --_g: 100% / var(--r) calc(2 * var(--r)) no-repeat;
            background: radial-gradient(
                        100% 50% at right,
                        #0005 98%,
                        #0000 101%
                    )
                    0 var(--_g),
                radial-gradient(100% 50% at left, #0005 98%, #0000 101%) 100%
                    var(--_g),
                conic-gradient(
                        from 90deg at var(--r) calc(100% - 2 * var(--r)),
                        #0000 25%,
                        var(--c) 0
                    )
                    0 0 / calc(100% - var(--r)) 100%;
        }
    }
    .partner-row-outer {
        &:hover {
            .partner-row {
                box-shadow: 0 0 #0000, 0 0 #0000,
                    0 10px 15px -3px rgb(0 0 0 / 0.1),
                    0 4px 6px -4px rgb(0 0 0 / 0.1);
                border: 1px solid var(--gw-btn-bg-color);
            }

            .logo {
                box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
                    0 8px 10px -6px rgba(0, 0, 0, 0.1);
                transform: scale(1.05);
            }

            .cta-button button {
                background: var(--gw-btn-bg-color);
                filter: brightness(102%);
                opacity: 0.9;
            }

            .review-link {
                text-decoration: underline;
            }

            .name {
                color: var(--gw-btn-bg-color);
                text-decoration: underline;
                text-underline-offset: 2px;
            }
            .discount-btn p {
                background: var(--gw-discount-btn-secondary-hover-color);
            }
        }
    }
    .partner-row {
        position: relative;
        padding: 24px 16px 16px 16px;
        display: flex;
        flex-direction: column;
        gap: 15px;
        align-items: center;
        border: 1px solid var(--gw-discount-btn-border-color);
        background: white;
        border-radius: 8px;
        box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

        @include mq('tablet') {
            align-items: flex-start;
        }

        @include mq('desktop') {
            gap: 0;
            display: grid;
            grid-template-areas:
                'logo name name'
                'logo desc rating'
                'review-link discount-btn cta-btn';
            grid-template-columns: 200px 2fr 1fr;
            grid-column-gap: 20px;
        }

        .logo {
            grid-area: logo;
            font-weight: bolder;
            width: 124px;
            height: 124px;
            padding: 12px;
            display: flex;
            justify-content: center;
            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
                0 1px 2px -1px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
            border: 1px solid var(--gw-discount-btn-border-color);
            transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
            order: 1;

            @include mq('desktop') {
                display: inherit;
                justify-content: normal;
            }

            img {
                object-fit: contain;
                width: 100%;
                height: 100%;
            }
        }
        .name {
            grid-area: name;
            font-size: 20px;
            font-weight: 600;
            transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
            order: 3;
        }
        .desc {
            grid-area: desc;
            width: 100%;
            font-size: 16px;
            line-height: 1.5;
            text-align: center;
            order: 5;
            @include mq('desktop') {
                text-align: inherit;
                margin: 10px 0;
            }

            ::v-deep strong {
                font-weight: 400;
            }
        }

        .rating {
            display: flex;
            gap: 5px;
            align-items: center;
            order: 4;

            @include mq('tablet') {
                position: absolute;
                top: 16px;
                right: 16px;
            }

            .score {
                font-weight: 600;
                margin-top: 0;
                font-size: 20px;
            }
            .rating-wrapper {
                justify-content: right;
            }

            @include mq('desktop') {
                text-align: right;
            }
        }

        .discount-btn {
            grid-area: discount-btn;
            width: 100%;
            overflow: hidden;
            align-self: flex-end;
            order: 7;

            p {
                margin: auto;
                border: 1px solid var(--gw-discount-btn-border-color);
                background: var(--gw-discount-btn-secondary-color);
                color: var(--gw-discount-btn-secondary-text-color);
                padding: 10px;
                font-size: 14px;
                max-width: fit-content;
                font-weight: bolder;
                border-radius: 5px;
                line-height: 18px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
                @include mq('desktop') {
                    margin: 0;
                }
            }
        }
        .cta-button {
            text-align: right;
            display: flex;
            order: 8;
            grid-area: cta-btn;
            justify-content: right;
            flex-direction: column;
            @include mq('tablet') {
                align-self: flex-end;
            }

            button {
                box-shadow: 0 3px 3px 0 rgba(0, 105, 191, 0.1);
                background: var(--gw-btn-bg-color);
                color: var(--gw-btn-text-color);
                text-align: center;
                padding: 10px;
                font-size: 14px;
                font-weight: 700;
                min-height: 40px;
                width: 100%;
                max-width: 250px;
                border-radius: 5px;
                cursor: pointer;
                z-index: 2;
                transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
            }
        }

        .icons {
            display: flex;
            justify-content: center;
            margin-bottom: 12px;
            margin-top: 12px;

            @include mq('desktop') {
                justify-content: flex-start;
                margin-top: 0;
            }
        }
    }
}
</style>
